import React from 'react'
import { Chat } from './Chat/Chat'
import { padding } from '@evrekadev/evreka-ui-components'
import { Button, Flex, Typography } from 'components'
import { useAIContext } from '../context/AIProvider'
import { useTranslation } from 'utils/useTranslation'
import styled from 'styled-components'
import { UilArrowLeft } from '@iconscout/react-unicons'

export const AssistantLayout: React.FC = () => {
  const { selectedAssistant, setPage } = useAIContext()
  const { t } = useTranslation('pages.ai')
  return (
    <Flex fullHeight fullWidth directionColumn="zero">
      <AssistantHeader>
        <Button
          variant="text"
          color="secondary"
          iconLeft={UilArrowLeft}
          onClick={() => setPage(undefined)}
        >
          {t('back')}
        </Button>
        <Typography fontSize="text_lg" fontWeight="medium">
          {t('starters.' + selectedAssistant?.title)}
        </Typography>
        <Typography fontSize="text_sm" fontWeight="regular" color="grey700">
          {t('starters.' + selectedAssistant?.description)}
        </Typography>
      </AssistantHeader>
      <Chat />
    </Flex>
  )
}

const AssistantHeader = styled.div`
  ${padding([8, 16])}
  display: flex;
  flex-direction: column;
  * {
    width: fit-content;
  }
`
